import React from "react";

import Banner from "../../sections/Banner/Banner";
import ContentBlock from "../../sections/ContentBlock/ContentBlock";

const shop = () => {
  return (
    <div>
      <Banner
        img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/gear-wide.jpg"
        img_alt="Gear"
      >
        <h1>Shop</h1>
      </Banner>
      <section>
        <h2>Shop exclusive DTC gear</h2>
        <h3>Limited run gear coming soon</h3>
        <ContentBlock>
          <img
            alt="DTC Sweatshirt"
            src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/gear/albert-sweatshirt.jpg"
          />
          <img
            alt="DTC Hat"
            src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/gear/rachel-hat.jpg"
          />
          <img
            alt="DTC Sweatshirt"
            src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/gear/quamel-sweatshirt.jpg"
          />
        </ContentBlock>
      </section>
    </div>
  );
};

export default shop;
